import {
  AlertaSdc,
  CondutaSdc,
  ConjuntoFatoresSdcDto,
  SdcFatoresVerificadosDto,
  SdcFatorVerificadoDto,
} from 'graphql/types.generated'
import { ProblemaCondicaoModel } from 'view/atendimentos/detail/soap/avaliacao/components/problemas-condicoes/model-problemasCondicoes'

export interface AlertaSuporteDecisaoClinica extends AlertaSdc {
  visualizado?: boolean
  exibido?: boolean
  comoFunciona?: string // TODO@CODEBENDERS passar esta prop para o backend #25422
}

export interface SdcAtendimentoValues {
  problemasCondicoes: ProblemaCondicaoModel[]
  prontuarioId: ID
  atendProfData: Date
  pesoCidadao: string
  isRegistroTardio: boolean
  isGravidezMultipla: boolean
  isBotaoPreNatalAtivo: boolean
}

export const isAlertaSdc = (obj: { __typename?: string }): obj is AlertaSuporteDecisaoClinica =>
  obj.__typename === 'AlertaSdc'

export const isCondutaSdc = (obj: { __typename?: string }): obj is CondutaSdc => obj.__typename === 'CondutaSdc'

export const conjuntoFatoresVerificadosPreEclampsiaSdc: ConjuntoFatoresSdcDto = {
  fatoresVerificadosSdc: {
    descricao:
      'No momento, o sistema avalia apenas fatores de alto risco, ou seja, aqueles em que <strong>a presença de um único fator já é suficiente para indicar o risco de pré-eclâmpsia.</strong>',
    fatores: [
      {
        fatorRisco: 'Diabetes mellitus',
        ondeSistemaVerifica: 'Lista de problemas e condições',
      },
      {
        fatorRisco: 'Hipertensão',
        ondeSistemaVerifica: 'Lista de problemas e condições',
      },
      {
        fatorRisco: 'Histórico de Pré-eclâmpsia, Eclâmpsia e HELLP em gestação anterior',
        ondeSistemaVerifica: 'Antecedentes<br>Lista de problemas e condições',
      },
      {
        fatorRisco: 'Gestação múltipla',
        ondeSistemaVerifica: 'Tipo de gravidez<br>Lista de problemas e condições',
      },
      {
        fatorRisco: 'Doença renal',
        ondeSistemaVerifica: 'Lista de problemas e condições',
      },
      {
        fatorRisco: 'Lúpus Eritematoso Sistêmico',
        ondeSistemaVerifica: 'Lista de problemas e condições',
      },
      {
        fatorRisco: 'Síndrome de Anticorpo Antifosfolipíde',
        ondeSistemaVerifica: 'Lista de problemas e condições',
      },
      {
        fatorRisco: 'Doença Falciforme',
        ondeSistemaVerifica: 'Lista de problemas e condições',
      },
      {
        fatorRisco: 'Fertilização in vitro',
        ondeSistemaVerifica: 'Lista de problemas e condições',
      },
      {
        fatorRisco: 'Obesidade',
        ondeSistemaVerifica: 'Lista de problemas e condições',
      },
      {
        fatorRisco: 'IMC ≥ 30 (IMC até 2 meses antes do início da gestação ou 8 semanas de IG)',
        ondeSistemaVerifica: 'Medições de antropometria',
      },
    ] as SdcFatorVerificadoDto[],
  } as SdcFatoresVerificadosDto,
  fatoresNaoVerificadosSdc:
    '<div><p>Fatores de risco moderado, listados abaixo, ainda não são avaliados pelo sistema <strong>e só indicam risco de pré-eclâmpsia quando há a presença de dois ou mais fatores.</strong> Caso o sistema não identifique risco de pré-eclâmpsia, o profissional deve verificar a presença destes fatores no prontuário:</p><ul><li>Nuliparidade</li><li>Intervalo de gravidez maior de 10 anos</li><li>Parente de primeiro grau (mãe ou irmã) com pré-eclâmpsia</li><li>Idade ≥ 35 anos</li><li>Raça negra (pretas e pardas)</li><li>Gravidez prévia com desfecho adverso (descolamento prematuro de placenta, nascimento prematuro, baixo peso ao nascer ou pequeno para idade gestacional, natimorto, restrição de crescimento fetal)</li><li>Outros marcadores sociais de risco</li></ul></div>',
}
